export default __webpack_public_path__ + "static/media/photo--sm--blitz-2.1043ae83.jpg";